import { render, staticRenderFns } from "./PedidoDialog.vue?vue&type=template&id=56dbfeb6"
import script from "./PedidoDialog.vue?vue&type=script&lang=js"
export * from "./PedidoDialog.vue?vue&type=script&lang=js"
import style0 from "./PedidoDialog.vue?vue&type=style&index=0&id=56dbfeb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports